var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-chart"},[_c('BaseChart',{ref:"chart",attrs:{"options":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }